import React, { ComponentProps, FC } from 'react';
import { BasicBadge, BasicBadgeVariantType } from '@dev/ee-components';
import { CampaignStatus, ContactStatus, DeliveryLogType, JourneyStatus } from '@dev/ee-api/ee-api-models';
import { useTranslation } from 'react-i18next';
import { toLower } from 'lodash-es';

const getProperBadge = (status: string) => {
    switch (status) {
        case ContactStatus.Active:
        case DeliveryLogType.Opened:
        case DeliveryLogType.Clicked:
        case 'Scheduled':
        case ContactStatus.Engaged:
            return BasicBadgeVariantType.Active;
        case DeliveryLogType.Sending:
        case CampaignStatus.Processing:
            return BasicBadgeVariantType.InProgress;
        case ContactStatus.Unsubscribed:
        case JourneyStatus.Paused:
            return BasicBadgeVariantType.Paused;
        case DeliveryLogType.ReadyToSend:
        case DeliveryLogType.Sent:
            return BasicBadgeVariantType.StatusName;
        case DeliveryLogType.Suppressed:
        case ContactStatus.NotConfirmed:
            return BasicBadgeVariantType.Disabled;
        case CampaignStatus.Completed:
            return BasicBadgeVariantType.Completed;
        case CampaignStatus.Cancelled:
        case ContactStatus.Inactive:
        case ContactStatus.Stale:
        case CampaignStatus.Deleted:
        case DeliveryLogType.WaitingToRetry:
            return BasicBadgeVariantType.Cancelled;
        case CampaignStatus.Draft:
        case ContactStatus.Transactional:
            return BasicBadgeVariantType.Draft;
        case DeliveryLogType.Bounced:
        case DeliveryLogType.AbuseReport:
        case ContactStatus.Abuse:
        case JourneyStatus.Invalid:
        case JourneyStatus.ShuttingDown:
        case DeliveryLogType.Error:
        default:
            return BasicBadgeVariantType.Invalid;
    }
};

type StatusBadgeT = ComponentProps<typeof BasicBadge> & { status?: string };

export const StatusBadge: FC<StatusBadgeT> = ({
    status,
    value,
    variant,
    borderDisabled = true,
    ...restOfProps
}: StatusBadgeT) => {
    const { t } = useTranslation();
    return (
        <BasicBadge
            variant={getProperBadge(status || variant)}
            value={t(toLower(value as string))}
            borderDisabled={borderDisabled}
            {...restOfProps}
        />
    );
};
